/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteLadderChallengeBody
 */
export interface CompleteLadderChallengeBody {
    /**
     * The MongoDB ObjectId of the winning participant
     * @type {string}
     * @memberof CompleteLadderChallengeBody
     */
    winnerOdId: string;
    /**
     * Optional notes from admin about the match completion
     * @type {string}
     * @memberof CompleteLadderChallengeBody
     */
    adminNotes?: string;
}

/**
 * Check if a given object implements the CompleteLadderChallengeBody interface.
 */
export function instanceOfCompleteLadderChallengeBody(value: object): value is CompleteLadderChallengeBody {
    if (!('winnerOdId' in value) || value['winnerOdId'] === undefined) return false;
    return true;
}

export function CompleteLadderChallengeBodyFromJSON(json: any): CompleteLadderChallengeBody {
    return CompleteLadderChallengeBodyFromJSONTyped(json, false);
}

export function CompleteLadderChallengeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteLadderChallengeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'winnerOdId': json['winnerOdId'],
        'adminNotes': json['adminNotes'] == null ? undefined : json['adminNotes'],
    };
}

export function CompleteLadderChallengeBodyToJSON(json: any): CompleteLadderChallengeBody {
    return CompleteLadderChallengeBodyToJSONTyped(json, false);
}

export function CompleteLadderChallengeBodyToJSONTyped(value?: CompleteLadderChallengeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'winnerOdId': value['winnerOdId'],
        'adminNotes': value['adminNotes'],
    };
}

